
<template>
    <div class="promotionGoodsSwiper-component">
        <van-swipe class="swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="goods of dataSource" :key="goods.spu_id">
                <div class="item">
                    <div class="goodsImage">
                        <div class="box">
                            <img v-lazy="goods.goods_img" alt="">
                        </div>
                        <div class="sellout" v-if="goods.goods_sell_out">已售罄</div>
                    </div>
                    <div class="goodsMsg">
                        <div class="goodsTitle">
                            <span class="van-multi-ellipsis--l2">{{goods.goods_name}}</span>
                        </div>
                        <div class="goodsPrice">
                            <span class="new">¥ {{goods.goods_present_price}}<span v-if="sstoreType">起</span></span>
                            <span class="old" v-if="goods.goods_price">¥ {{goods.goods_price}}</span>
                        </div>
                        <div class="buy">
                            <van-button :class="{grey: goods.goods_sell_out}" type="danger" round @click="goGoodsDetail(goods)">立即购买</van-button>
                        </div>
                    </div>
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script >
import { Swipe, SwipeItem, Button } from 'vant'
export default {
    name: 'promotionGoodsSwiper',
    props: {
        dataSource: {
            type: Array,
            required: true
        },
        sstoreType: {
            type: Boolean,
            default: true
        }
    },
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Button.name]: Button,
    },
    data () {
        return {

        }
    },
    created () {

    },
    activated () {

    },
    mounted () {

    },
    methods: {
        goGoodsDetail (goods) {
            const params = {value: {spec_id: goods.spec_id, spu_id: goods.spu_id}, cb: this.goPage}
            !this.sstoreType && Object.assign(params.value, {goods_type: goods.goods_type})
            this.$emit('callback', params)
        },
        goPage (params) {
            this.$router.push({
                path: this.sstoreType ? '/moreSstoreGoodsDetail' : '/goodsDetail', // true：跳转多店， false：跳转单店
                query: params
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "../../../assets/stylus/variables";

.promotionGoodsSwiper-component
    padding 0 30px
    .swipe
        padding-bottom  60px
</style>
<style lang="stylus">
    .promotionGoodsSwiper-component
        .swipe
            border-radius 10px
            overflow hidden
            .van-swipe__track
                border-radius 10px
        .van-swipe-item
            .item
                display flex
                background-color $fcWhite
                border-radius 10px
                .goodsImage
                    position relative
                    margin 29px 29px 30px 20px
                    width 231px
                    height 231px
                    .box
                        position relative
                        width 100%
                        padding-top 100%
                        overflow hidden
                        img
                            position absolute
                            top 0
                            left 0
                            width 100%
                            height 100%
                    .sellout
                        position absolute
                        top 65px
                        right 0
                        left 0
                        width 100px
                        height 100px
                        line-height 100px
                        margin auto
                        background-color rgba(0, 0, 0, 0.5)
                        color $fcWhite
                        font-size $fontListTitle
                        border-radius 50%
                        text-align center
                .goodsMsg
                    width calc(100% - 280px)
                    padding 32px 31px 0 0
                    box-sizing border-box
                    .goodsTitle
                        font-size $fontBase
                        color $black333
                        height 64px
                        line-height 1.2
                        span
                            word-break break-all
                    .goodsPrice
                        padding 18px 0 43px
                        .new
                            font-size $fontListTitle
                            color $fcRed
                        .old
                            font-size $fontSmall
                            color $fcGreyish
                            text-decoration line-through
                            padding-left 20px
                    .buy
                        .van-button
                            display flex
                            align-items center
                            height 60px
                            line-height 60px
                            background-color $fcRed
                            border-radius 29px
                            font-size $fontSmall
                            &.grey
                                background-color $fcGrey
                                border-color $fcGrey
    .van-swipe__indicator
        width 20px
        border-radius 2px
        background $fcWhite
</style>
